import { useState, useEffect, useMemo, useRef } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { getPowerups, deletePowerup } from "../../../api/powerupApi";
import "./PowerupTable.css";

import useShopItems from "../../../hooks/useShopItems";

export default function PowerupTable({ searchText, selectedFilter }) {
  const [powerups, setPowerups] = useState([]);
  const [openMenu, setOpenMenu] = useState(null);
  const [loading, setLoading] = useState(true);
  const isFirstLoad = useRef(true);

  const { fetchPower, powerupItems, loadingPowerupItems } = useShopItems();

  useEffect(() => {
    const fetchData = async () => {
      await fetchPower();
    };
    fetchData();
  }, []);

  // useEffect(() => {
  //   if (localStorage.getItem("lastSeenPowerupCount") === null) {
  //     localStorage.setItem("lastSeenPowerupCount", "0");
  //   }
  //   fetchPowerups();
  // }, []);

  const fetchPowerups = async () => {
    try {
      setLoading(true);
      const data = await getPowerups();

      const tableData = data.map((p, index) => ({
        srn: index + 1,
        _id: p._id,
        itemName: p.name,
        itemCategory: "Powerup",
        itemSubCategory: p.type,
        coin: p.strengthPlus,
        itemUsage: p.temporaray ? `${p.duration}s` : "Permanent",
        createdAt: "-",
        status: p.temporaray ? "Temporary" : "Permanent",
      }));

      setPowerups(tableData);
      isFirstLoad.current = false;
    } catch (err) {
      console.error("Failed to load powerups", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    try {
      await deletePowerup(id);
      setPowerups((prev) => prev.filter((item) => item._id !== id));
      setOpenMenu(null);
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  const filteredData = useMemo(() => {
    let result = powerups;

    if (selectedFilter && selectedFilter !== "All") {
      result = result.filter(
        (p) => p.itemSubCategory.toLowerCase() === selectedFilter.toLowerCase(),
      );
    }

    if (searchText.trim()) {
      const query = searchText.toLowerCase();
      result = result.filter(
        (p) =>
          p.itemName.toLowerCase().includes(query) ||
          p.itemCategory.toLowerCase().includes(query) ||
          p.itemSubCategory.toLowerCase().includes(query) ||
          p.status.toLowerCase().includes(query),
      );
    }

    return result;
  }, [powerups, selectedFilter, searchText]);

  return (
    <div className="powerup-table-wrapper">
      <div className="powerup-table-container">
        {/* Header */}
        <div className="powerup-table-header">
          <div>SRN</div>
          <div>Name</div>
          <div>Magnet Price</div>
          <div>Speed Price</div>
          {/* <div>Coins</div>
          <div>Usage</div>
          <div>Added At</div>
          <div>Status</div> */}
          {/* <div className="align-right">Action</div> */}
        </div>

        {/* Body */}
        <div className="powerup-table-body">
          {loadingPowerupItems ? (
            <div className="table-message">Loading...</div>
          ) : !loadingPowerupItems && powerupItems.length === 0 ? (
            <div className="table-message">No items found.</div>
          ) : (
            powerupItems.map((item, index) => (
              <div key={item._id} className="powerup-table-row">
                <div>{index + 1}</div>
                <div>Power Up</div>
                <div>{item.magnet.price}</div>
                <div>{item.speed.price}</div>
                {/* <div>{item.coin}</div>
                <div>{item.itemUsage}</div>
                <div className="date">
                  {item.createdAt !== "-"
                    ? new Date(item.createdAt).toLocaleString()
                    : "-"}
                </div>
                <div>
                  <span
                    className={`status ${
                      item.status === "Temporary" ? "warning" : "success"
                    }`}
                  >
                    {item.status}
                  </span>
                </div> */}

                {/* Actions */}
                {/* <div className="action-cell">
                  <button
                    className="action-btn"
                    onClick={() =>
                      setOpenMenu(openMenu === item._id ? null : item._id)
                    }
                  >
                    <BsThreeDotsVertical />
                  </button>

                  {openMenu === item._id && (
                    <div className="action-menu">
                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(item._id)}
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div> */}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
